import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Col, Divider, Row } from 'antd';

import { Block, Title } from '../..';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import { formatNumber } from 'utils/helper';

interface Props {
  transactionData: Record<string, any>;
}

const Payment: React.FC<Props> = ({ transactionData }) => {
  const translations = useSelector(selectTranslations);

  const renderPaymentInfo = useCallback(
    value => {
      const valueAsNumber = +value;
      if (
        value !== null &&
        value !== undefined &&
        typeof valueAsNumber === 'number' &&
        !isNaN(valueAsNumber)
      )
        return `${formatNumber(value).replaceAll(',', '.')}đ`;
      return translations?.['b2b.txt.updating'] ?? '';
    },
    [translations],
  );

  return (
    <Block>
      <Title>{translations?.['b2b.txt.agent-pay'] ?? ''}</Title>
      <Divider dashed style={{ borderColor: '#EDEDED', margin: '16px 0' }} />
      <Row style={{ flexDirection: 'column' }} gutter={[24, 24]}>
        <Col>
          <PaymentTitle>
            {translations?.['b2b.txt.agent-deposit-surplus'] ?? ''}
          </PaymentTitle>
          <PaymentValue style={{ color: '#FAB317' }}>
            {renderPaymentInfo(transactionData?.amount)}
          </PaymentValue>
        </Col>
        <Divider
          dashed
          style={{ margin: '0px 12px', borderColor: '#EDEDED' }}
        />
        <Col>
          <PaymentTitle>
            {translations?.['b2b.txt.credit-limit-granted'] ?? ''}
          </PaymentTitle>
          <PaymentValue>
            {renderPaymentInfo(transactionData?.creditLimitAmount)}
          </PaymentValue>
        </Col>
        <Col>
          <PaymentTitle>
            {translations?.['b2b.txt.agent-dept'] ?? ''}
          </PaymentTitle>
          <PaymentValue>
            {renderPaymentInfo(transactionData?.totalAmount)}
          </PaymentValue>
        </Col>
        <Col>
          <PaymentTitle>
            {translations?.['b2b.txt.agent-available-limit'] ?? ''}
          </PaymentTitle>
          <PaymentValue>
            {renderPaymentInfo(transactionData?.availableCredit)}
          </PaymentValue>
        </Col>
      </Row>
    </Block>
  );
};

export default Payment;

const PaymentTitle = styled.p`
  font-size: 14px;
  margin: 0;
  color: #000000;
  font-weight: 400;
`;

const PaymentValue = styled.p`
  font-size: 20px;
  margin: 0;
  color: #000000;
  font-weight: 500;
  margin-top: 4px;
`;
